/* @flow */

import { buttonModalActionMaker } from '@website/components/ActionMakers'
import { addButton } from '@website/components/CommonActions'

export default dispatcher => ({
  addButton: idx => dispatcher(addButton(idx)),
  getButtonActions: buttonModalActionMaker(dispatcher)
})
